<template>
  <div id="Header_G">
    <div class="xv_navbar">
      <div class="row">
        <div class="col-6 xv_brand">
          <div class="xv_brand_logo">
            <img src="../../../assets/Thermometer_green.png" alt />
          </div>
          <div class="xv_brand_name">
            <span>Xerovi</span>
          </div>
        </div>
        <div class="col-6 xv_options">
          <!-- <div class="xv_lang">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              right
            >
              <template v-slot:button-content>
                <span>En</span>
              </template>
              <b-dropdown-item href="#">En</b-dropdown-item>
              <b-dropdown-item href="#">Es</b-dropdown-item>
              <b-dropdown-item href="#">Fr</b-dropdown-item>
            </b-dropdown>
          </div>-->
          <div class="demo_info_wrap">
            <div class="demo_info">
              <div class="count">8</div>
            </div>
            <div class="text">days left in demo</div>
            <div>
              <button class="main_btn">Upgrade</button>
            </div>
          </div>
          <div class="xv_user">
            <b-dropdown variant="link" toggle-class="text-decoration-none" right>
              <template v-slot:button-content>
                <img class="cvc_user_logo" src="../../../assets/user.jpg" alt />
              </template>
              <b-dropdown-item href="#">
                <span class="mdi mdi-account"></span>Account
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <span class="mdi mdi-login"></span>Sign out
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 xv_nav_list">
          <button :class="{ active: active_nav == 'dashboard' }" @click="nav('dashboard')">
            <span class="mdi mdi-view-dashboard"></span>Dashboard
          </button>
          <button :class="{ active: active_nav == 'users' }" @click="nav('users')">
            <span class="mdi mdi-account"></span>Users
          </button>
          <button :class="{ active: active_nav == 'citizens' }" @click="nav('citizens')">
            <span class="mdi mdi-account-group"></span>Citizens
          </button>
          <button :class="{ active: active_nav == 'hospitals' }" @click="nav('hospitals')">
            <span class="mdi mdi-hospital-building"></span>Hospitals
          </button>
          <button
            :class="{ active: active_nav == 'testing_centers' }"
            @click="nav('testing_centers')"
          >
            <span class="mdi mdi-warehouse"></span>Testing centers
          </button>
          <button
            :class="{ active: active_nav == 'quarantine_facilities' }"
            @click="nav('quarantine_facilities')"
          >
            <span class="mdi mdi-home-alert"></span>Quarantine facilities
          </button>
          <button :class="{ active: active_nav == 'reports' }" @click="nav('reports')">
            <span class="mdi mdi-clipboard-text"></span>Reports
          </button>
          <button :class="{ active: active_nav == 'cases' }" @click="nav('cases')">
            <span class="mdi mdi-alert-rhombus"></span>Cases
          </button>
          <button :class="{ active: active_nav == 'alerts' }" @click="nav('alerts')">
            <span class="mdi mdi-email"></span>Alerts
            <sup class="xv_msg_count">4</sup>
          </button>
        </div>
      </div>
    </div>
    <div class="xv_skeleton"></div>
  </div>
</template>

<script>
export default {
  name: "Header_G",
  components: {},

  data() {
    return {
      active_nav: "dashboard"
    };
  },
  mounted() {
    var path = this.$route.path;
    var current_path = path.split("/");
    this.active_nav = current_path[current_path.length - 1];
  },
  methods: {
    nav: function(nav) {
      this.active_nav = nav;
      this.$router.push(nav);
    }
  }
};
</script>
